var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PagContainer',{ref:"decorateRef",staticClass:"pag-canvas decorate-canvas",attrs:{"useScale":true,"scaleMode":3,"autoPlay":false,"pagSrc":_vm.decoratePagSrc,"loop":0},on:{"onReady":_vm.handlePagReady}})}
var staticRenderFns = []

export { render, staticRenderFns }